/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ds_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. All conversion happens in your browser; nothing is uploaded.`)
};

const es_ds_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Toda la conversión ocurre en tu navegador; nada se carga.`)
};

const de_ds_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Die gesamte Umrechnung erfolgt in Ihrem Browser; nichts wird hochgeladen.`)
};

const nl_ds_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Alle conversie vindt plaats in uw browser; niets wordt geüpload.`)
};

const fr_ds_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Toute conversion se fait dans votre navigateur; rien n'est téléchargé.`)
};

const it_ds_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Tutta la conversione avviene nel tuo browser; nulla viene caricato.`)
};

const pt_br2_ds_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Toda conversão acontece no seu navegador; nada é enviado.`)
};

const pt_ds_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Toda a conversão ocorre no seu navegador; nada é carregado.`)
};

const ja_ds_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。すべての変換はブラウザで行われます。何もアップロードされません。`)
};

const zh_ds_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。所有换算都在你的浏览器中完成,不会上传任何数据。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ds_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ds_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ds_faq3_a", locale)
	if (locale === "en") return en_ds_faq3_a(inputs)
	if (locale === "es") return es_ds_faq3_a(inputs)
	if (locale === "de") return de_ds_faq3_a(inputs)
	if (locale === "nl") return nl_ds_faq3_a(inputs)
	if (locale === "fr") return fr_ds_faq3_a(inputs)
	if (locale === "it") return it_ds_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_ds_faq3_a(inputs)
	if (locale === "pt") return pt_ds_faq3_a(inputs)
	if (locale === "ja") return ja_ds_faq3_a(inputs)
	return zh_ds_faq3_a(inputs)
};